import React from "react";

const HcHero = ({ image, h1, h2 }) => {
  return (
    <div className="wp-block-kehittamo-block-hc-hero wp-block-kehittamo-block-hc !aspect-w-5 !aspect-h-4 xl:!aspect-w-16 xl:!aspect-h-9">
      <div
        className="w-full h-full relative flex flex-col justify-center items-center gap-6 p-2 overflow-hidden"
        style={{
          background: `linear-gradient(105deg, rgba(31, 122, 167, 1) 0%, rgba(255, 255, 255, 0.5) 50%, rgba(240, 96, 29, 1) 100%), url(${image.src}) center / cover`,
        }}
      >
        <div className="absolute opacity-50 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[125%] h-3/4 bg-[url('/wp-content/themes/muotolevy/dist/images/hurl.png')] bg-center bg-contain bg-no-repeat" />
        {h1 && (
          <h1 className="relative z-1 !text-black font-bold text-center w-4/5 m-0 p-0 xl:text-[80px]">
            {h1}
          </h1>
        )}
        {h2 && (
          <h2 className="relative z-1 m-0 text-lg text-center font-medium italic !text-muotolevy-red bg-white rounded-full py-[0.75rem] px-[1.5rem] xl:!py-[24px] xl:!px-[32px] xl:text-[30px]">
            {h2}
          </h2>
        )}
      </div>
    </div>
  );
};

export default HcHero;
